import { Select, SelectProps } from 'antd';
import { ScopeType } from '../types';
import { useTranslate } from '@tolgee/react';

export default function ScopeSelect(props: SelectProps<ScopeType>) {
  const { t } = useTranslate();

  return (
    <Select
      dropdownMatchSelectWidth={false}
      options={[
        { label: t('全部平台'), value: 'ALL_PLATFORMS' },
        { label: t('指定平台'), value: 'SPECIFIED_PLATFORMS' },
        { label: t('指定站点'), value: 'SPECIFIED_REGIONS' },
        { label: t('指定平台&站点'), value: 'SPECIFIED_PLATFORMS_REGIONS' },
      ]}
      placeholder={t('请选择')}
      style={{ width: '100%' }}
      {...props}
    />
  );
}
